module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "src": "/static/img/backToTop/back_to_top_2x.png",
      "alt": "Top"
    },
    on: {
      "click": _vm.backToTop
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16f167b3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backToTop/BackToTop.vue
// module id = 1269
// module chunks = 1